import powerInvestigate from '@/assets/power-investigate.png';
import powerExecution from '@/assets/power-execution.png';
import powerPeek from '@/assets/power-peek.png';
import powerElection from '@/assets/power-election.png';

export { powerInvestigate, powerExecution, powerPeek, powerElection };

export const powerImageMap: Record<string, string> = {
  investigate_loyalty: powerInvestigate,
  policy_peek: powerPeek,
  special_election: powerElection,
  execution: powerExecution,
  investigate: powerInvestigate,
  peek: powerPeek,
  election: powerElection,
};
